
function guestLoginDialog () {
  return {
    restrict: 'E',
    templateUrl: '/guest/dialogs/guest-login/guest-login-dialog.html?$$REVISION$$'
  }
}

export { guestLoginDialog }
